<template>
  <div class="menu-item" @click="onItemClick()">
    <div class="menu-item__icon"></div>
    <div class="menu-item__text">{{ item.text }}</div>
  </div>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onItemClick() {
      this.$emit("MenuItemClick", this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: $background-lines-WIDTH;
  white-space: nowrap;

  color: $ui-white;
  @include link-M;
  text-transform: uppercase;
  cursor: pointer;
  pointer-events: all;

  &__icon {
    background-color: $primary-yellow;
    width: toRem(6);
    height: toRem(20);
    margin-right: toRem(15);
    transition: all 0.5s ease;
    flex-shrink: 0;
    :hover > & {
      transform: translate(toRem(6), toRem(-1)) rotate(90deg);
      margin-right: toRem(5);
    }
  }

  &__text {
    transition: all 0.5s ease;
    :hover > & {
      transform: translateX(toRem(17));
    }
  }
}
</style>
